/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".content[_ngcontent-%COMP%]{padding:75px 20px 20px}.content[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-bottom:50px}.content[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{width:100%}.close-button[_ngcontent-%COMP%]{position:absolute;right:8px;top:8px}@media (min-width:768px){.content[_ngcontent-%COMP%]{padding:75px 48px 72px}.content[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-bottom:40px}.content[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{width:auto}.close-button[_ngcontent-%COMP%]{right:24px;top:24px}}"];
export { styles as styles };
